export default {
  feedbackTitle: '트랜싯 구매',
  swap: '스왑&브리지',
  markets: '마켓',
  comingSoon: '곧 출시 예정',
  startNow: '지금 시작',
  copied: '복사됨',
  verifyHuman: 'Verify Human',

  header: {
    buyToken: '암호화폐 구매',
    searchTokens: '토큰 검색',
    recentSearches: '최근 검색',
    popularTokens: '인기 토큰',
    noSearchContent: '찾을 수 있는 토큰이 없습니다.',
    markets: '마켓',
    inscribeTool: '인스크라이브 도구',
  },

  appSetting: {
    theme: '테마',
    light: '라이트',
    dark: '다크',
    auto: '자동',

    language: '언어',
    langText: '영어',

    showChart: '차트 표시',
    contactUs: '문의하기',
  },

  home: {
    modal_contact_us: {
      title: '문의하기',
      text_1: "* 트랜싯은 절대 먼저 연락하지 않으며, 어떠한 요금도 부과하지 않습니다.",
      text_2: '트랜싯 구매 문의',
      serviceEmail: '서비스 이메일',
      telegram: '텔레그램',
      X: 'X (트위터)',
      tips: 'OnRamp 관련 문의에 대해서만 가능합니다.',
      desc1: "트랜싯 파이낸스 직원은 절대 개인 메시지를 보내지 않습니다!",
      desc2: "주의! 트랜싯 커뮤니티에 입장합니다. 누군가가 우리를 사칭하여 개인 메시지를 보낼 수 있습니다! 개인 메시지를 보내는 사람이 사기일 수 있음을 유의하시기 바랍니다! 우리는 절대 먼저 연락하지 않습니다!",
      desc3: '알겠습니다, 입장',
      tg_text_1: '트랜싯 파이낸스 직원은 절대 저에게 먼저 연락하지 않습니다!',
      tg_text_2: '저에게 개인 메시지를 보내는 사람은 사기일 수 있습니다!',
      tg_text_3: '저는 누구와도 제 개인 정보(시드 구문 또는 개인 키 포함)를 공유하지 않겠습니다!',
    },
    text_1_1: '구매 ',
    text_1_2: '암호화폐',
    text_1_3: '더 쉽게',
    text_1_4: '트랜싯 구매와 함께',
    text_2: '암호화폐',
    text_3: '국가',
    text_4: '우리의 파트너들',
    text_5: '신뢰할 수 있는 파트너와 결제 방법을 통해 암호화폐를 사고 팔 수 있습니다.',
    text_6: '더 많은 선택, 더 나은 경험.',
    text_7: '암호화폐를 더 쉽고 편리하게!',
    text_8: '100개 이상의 암호화폐와 150개 이상의 법정화폐를 사용하여 좋아하는 결제 방법으로 거래할 수 있습니다.',
    text_9: '최고의 가격',
    text_10: '우리는 파트너로부터 가격을 조회하고 목록으로 표시합니다. 최고의 가격을 선택하고 지원되는 결제 방법을 확인할 수 있습니다.',
    text_11: '개인 정보 보호',
    text_12: '구매 또는 판매 과정에서 개인 정보, 신원 정보 및 결제 정보는 보호되며 공개되지 않습니다.',
    text_13: '진정한 소유',
    text_14: '암호화폐를 구매한 후, 이는 직접 당신의 지갑 주소로 전송되어 자유롭고 제한 없는 암호화폐 전송이 가능합니다. 당신은 그것을 진정으로 소유합니다!',
    text_15: '지금 암호화폐 여정을 시작하세요',
    text_16: '100개 이상의 암호화폐와 150개 이상의 법정화폐로 구매 및 판매',
    card_text_1: '좋아하는 결제 방법 선택',
    card_text_2: '세계 최고의 온램프 파트너들이 지원',
    card_text_3: '전 세계 100개 이상의 국가 및 지역을 커버합니다.',
    card_text_4: 'USD, EUR, HKD, SGD, GBP 및 150개 이상의 다른 법정화폐 지원.',
    card_text_5: 'USDT, BTC, ETH, TRX 및 100개 이상의 암호화폐 상장.',
  },

  ramp: {
    buy: '구매',
    sell: '판매',
    selectCurrency: '통화 선택',
    toBuy: '구매하기',
    payWith: '결제 방법',
    selectToken: '토큰 선택',
    placeholder: '토큰 검색',
    placeholder1: '법정화폐 검색',
    popular: '인기',
    all: '전체',
    creditCard: '결제 방법',
    providerTitle: '제공자 선택',
    providerDesc: '당신에게 가장 적합한 제공자를 선택하세요!',
    providerDesc_1: '{currencyAmt} {currencyCoin}을 {cryptCoin}으로 변환 중입니다, 당신에게 가장 적합한 제공자를 선택하세요!',
    providers: '제공자들',
    noProviders: '서비스 제공자가 없습니다~',
    estimated: '예상 수령',
    receiveAddress: '수령 주소',
    confirm: '확인',
    next: '다음',
    validAddress: '유효한 주소',
    limitAmount: '한도 금액',
    quotesStopped: '오류, 인용 중지됨!',
    restart: '재시작',
    addressRequired: '지갑 주소가 필요합니다',
    paymentRequired: '결제 방법이 필요합니다',
    emptyText: '해당 결제 방법이 없습니다',
    orderFailed: '주문 실패, 다시 시도하세요',
    googlePayText_1: '선택한 결제 방법은 구글 페이입니다. 아래 단계를 따라주세요.',
    googlePayText_2: '우리는 리디렉션 URL을 복사했습니다.',
    googlePayText_3: '시스템 브라우저를 열고 URL을 붙여넣어 웹사이트를 방문하세요.',
    feeOff: '50% 할인',
    hot: '핫',
  },

  footer: {
    Features: {
      title: '기능',
      swap: '스왑&브리지',
      bridge: '브리지',
      market: '마켓',
      buyCrypto: '암호화폐 구매',
      explorer: '탐색기',
    },
    NFT: {
      title: 'NFT',
      design: '디자인',
      transitNFT: '트랜싯 NFT',
      marketplace: '마켓플레이스',
    },
    Governance: {
      title: '거버넌스',
      dao: 'DAO',
      donation: '기부',
      fee: '수수료',
    },
    Community: {
      title: '커뮤니티',
      developers: '개발자',
      forum: '포럼',
      twitter: '트위터',
      downloadTP: 'TokenPocket 다운로드',
    },
    Help: {
      title: '도움 받기',
      contactUs: '문의하기',
      helpCenter: '헬프 센터',
    },
    Links: {
      title: '링크',
      TP: 'TokenPocket',
      Trading_View: '트레이딩 뷰',
      Terms: '이용 약관',
      Privacy_Policy: '개인정보 보호정책',
      bugBounty: '버그 바운티',
    },
  },
};
